<div class="d-flex justify-content-center">
    <div style="width: 400px;">
        <div class="card card-border-color card-border-color-primary p-shadow-8 d-flex justify-content-center">
            <app-about-me-header></app-about-me-header>
            <div *ngIf="!customerKey">
                <app-about-me-login (customerKeyChange)="customerKey = $event"></app-about-me-login>
            </div>
            <div *ngIf="customerKey">
                <app-about-me-detail [(customerKey)]="customerKey"></app-about-me-detail>
            </div>
            
            <div class="d-flex justify-content-center">
                <app-terms-of-service-footer></app-terms-of-service-footer>
            </div>
        </div>
    </div>
</div>